import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ApplicationState } from "store";
import { getId } from "user/store";
import { UserList } from "page/user/list/user-list";
import { getResource } from "resource/store";

const mapStateToProps = (state: ApplicationState) => ({
    loggedInUserId: getId(state),
    Admin_Dashboard_Users: getResource(state, {
        key: "Admin_Dashboard_Users",
    }),
    Admin_Dashboard_Users_Username: getResource(state, {
        key: "Admin_Dashboard_Users_Username",
    }),
    Admin_Dashboard_Users_Email: getResource(state, {
        key: "Admin_Dashboard_Users_Email",
    }),
    Admin_Dashboard_Users_Roles: getResource(state, {
        key: "Admin_Dashboard_Users_Roles",
    }),
    Admin_Dashboard_Users_New: getResource(state, {
        key: "Admin_Dashboard_Users_New",
    }),
    Admin_Order_Search: getResource(state, {
        key: "Admin_Order_Search",
    }),
    Loading: getResource(state, {
        key: "Loading",
    }),
});

const connectedComponent = connect(mapStateToProps)(UserList);

export default withRouter(connectedComponent);
